import { Flex, FormLabel, useColorModeValue } from '@chakra-ui/react'; 
import {
  Select,
} from "chakra-react-select";


export default function OperacionSelect(props: { selectedValue: any; onChange: any; includeGlobal?: boolean;
})  {
	
  const TITLE = 'Operación'
  const KEY_FILTER = "operacionSelect";
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  
 const data =[]

 if (props.includeGlobal)
 {
  data.push({value : '%', label : 'Todas'});
 }

 data.push({value : '1', label : 'Importación'}, {value : '2', label : 'Exportación'});
	
		const options = data.map(item => {
			return {
        value: item.value,
        label: `${item.label}`,
    };
		});

   
	return (    
    <Flex direction='column'>
							<FormLabel
								ms='10px'
								htmlFor={KEY_FILTER}
								fontSize='sm'
								color={textColorPrimary}
								fontWeight='bold'
								_hover={{ cursor: 'pointer' }}>
								{TITLE}
							</FormLabel>
    <Select
								fontSize='sm'
								id={KEY_FILTER}
								variant='main'
								h='44px'
								maxH='44px'
								me='20px'
								defaultValue={
                  props.selectedValue != ''
                    ? options.filter((r) => r.value == props.selectedValue)
                    : options[0]
                }
                options={options}
                onChange={(selected) => props.onChange(selected.value)}
                />
                </Flex>
  );
}